import { render, staticRenderFns } from "./medicina-ocupacional-dangerEditar.vue?vue&type=template&id=ab8d8708&"
import script from "./medicina-ocupacional-dangerEditar.vue?vue&type=script&lang=js&"
export * from "./medicina-ocupacional-dangerEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports